(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('HubspotDealDeleteController',HubspotDealDeleteController);

    HubspotDealDeleteController.$inject = ['$uibModalInstance', 'entity', 'HubspotDeal'];

    function HubspotDealDeleteController($uibModalInstance, entity, HubspotDeal) {
        var vm = this;

        vm.hubspotDeal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HubspotDeal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
